import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TOS_VERSION } from "@/components/terms-of-service-text";

import { useProfileQuery } from "@/queries/user/profile";
import { useAcceptTermsOfService } from "@/mutations/user/accept-terms-of-service";

const TermsOfServiceAgreementDialog = () => {
  const { profile } = useProfileQuery();
  const { pathname } = useLocation();

  const { logout } = useAuth0();

  const { acceptTermsOfService, isAcceptingTermsOfService } =
    useAcceptTermsOfService();

  const openTos = () => {
    window.open(`/terms-of-service`, "_blank");
  };

  const onAgree = () => {
    acceptTermsOfService();
  };

  const onDisagree = () => {
    void logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  if (
    !profile ||
    profile.tosVersionAgreement === TOS_VERSION ||
    pathname.startsWith("/terms-of-service") ||
    pathname.startsWith("/pre-screen")
  ) {
    return;
  }

  return (
    <Dialog
      open={profile && profile.tosVersionAgreement !== TOS_VERSION}
      onOpenChange={undefined}
    >
      <DialogContent className="p-0" noClose>
        <DialogHeader>
          <DialogTitle className="sr-only">
            Review Terms & Conditions
          </DialogTitle>
          <DialogDescription className="sr-only">
            Review and accept Venturous&apos; Terms & Conditions
          </DialogDescription>
        </DialogHeader>
        <div className="p-4 w-full flex flex-col gap-3 items-center">
          <h2 className="text-brand-neutral-black text-lg font-bold text-center">
            I have read and agree to Venturous&apos; Terms & Conditions.
          </h2>
          <Button
            type="button"
            className="mt-2"
            variant="ghost"
            onClick={openTos}
          >
            Terms & Conditions
          </Button>
          <div className="w-full flex flex-col justify-between">
            <Button
              type="button"
              className="mt-2"
              variant="secondary"
              onClick={onAgree}
              disabled={isAcceptingTermsOfService}
            >
              Accept
            </Button>
            <Button
              type="button"
              className="mt-2"
              variant="outline"
              onClick={onDisagree}
              disabled={isAcceptingTermsOfService}
            >
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsOfServiceAgreementDialog;
